import { render, staticRenderFns } from "./EstadisticasView.vue?vue&type=template&id=261ff2b9"
import script from "./EstadisticasView.vue?vue&type=script&lang=js"
export * from "./EstadisticasView.vue?vue&type=script&lang=js"
import style0 from "./EstadisticasView.vue?vue&type=style&index=0&id=261ff2b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports